import comp from "./ItemViewFeed";
export default comp;
